import Consts from '../../consts/adminConsts'

export default class {
    Id = null;

    Name = "";

    IsNeedCheck = false;

    AuditType = null;

    Status = null;

    BlockIds = [];

    TagIds = [];

    mapFromDto = function (viewModel) {
        let dto = viewModel;
        if(!dto)
            return this;

        this.Id = dto.Id;
        this.Name = dto.Name;
        this.AuditType = Consts.AuditType.find(e => e.Id == dto.AuditType);
        this.Status = Consts.ActivityAuditStatus.find(e => e.Id == dto.Status);
        this.IsNeedCheck = dto.IsNeedCheck;
        this.BlockIds = dto.BlockIds;
        this.TagIds = dto.TagIds;

        return this;
    }

    mapToDto = function (){
        let dto = JSON.parse(JSON.stringify(this)); 

        dto.AuditType = dto.AuditType.Id;
        dto.Status = dto.Status.Id;
        dto.TagIds = dto.TagIds.map(t => t.Id);
        dto.BlockIds = dto.BlockIds.map(b => b.Id);
        dto.IsNeedCheck = dto.IsNeedCheck;
        
        return dto;
    }

    isInValid = () => {
        if( this.Name == "" ||
            this.AuditType == null ||
            this.Status == null) {
                return 1;
            }                 
        else if( this.BlockIds.some(item => (item == null || item.Id == "")) ||
                 this.BlockIds.length == 0) {
                return 2;
            }
        else return 0;
    }
}